<template>
  <a-modal
    centered
    :maskClosable="false"
    title="抹零"
    v-model="visible"
    width="500px"
    @ok="onSubmit"
    @cancel="onCancel"
    :okButtonProps="{
      props: {
        disabled: disabledOk
      }
    }"
    :confirmLoading="confirmLoading"
  >
    <div class="form-item">
      <label>待收金额：</label>
      <span style="color:#f00;font-size:18px"> &yen; {{ unPayAmount }} </span>
    </div>
    <div class="form-item">
      <label>抹零金额：</label>
      <span>{{ freeAmount }} </span>
      <span
        style="color:#f60;font-size:12px;margin-left:5px"
        v-if="disabledOk && errMsg"
      >
        （{{ errMsg }}）</span
      >
    </div>
    <div class="form-item">
      <label>抹零后金额：</label>
      <span>
        <a-input-number
          :min="0"
          :precision="2"
          :max="unPayAmount"
          v-model="MoneyAfterFreeRemnant"
          @change="changeFree"
          @blur="handleBlur"
        ></a-input-number>
      </span>
    </div>
  </a-modal>
</template>

<script>
import { accSub } from "@/utils/common";
export default {
  components: {},
  data() {
    return {
      visible: false,
      MoneyAfterFreeRemnant: 0,
      unPayAmount: 0,
      confirmLoading: false,
      resConfig: {},
      disabledOk: false,
      errMsg: ""
    };
  },
  computed: {
    freeAmount() {
      if (Number(this.MoneyAfterFreeRemnant) >= 0) {
        return accSub(this.MoneyAfterFreeRemnant, this.unPayAmount);
      }
      return 0;
    }
  },
  created() {
    this.$post("GetRestaurantConfig", {}).then(res => {
      this.resConfig = res.Data;
    });
  },
  methods: {
    show(info) {
      this.visible = true;
      this.info = info;
      this.unPayAmount = this.info.UnPayAmount;
      this.disabledOk = false;
      this.MoneyAfterFreeRemnant = this.info.UnPayAmount;
    },
    changeFree() {
      this.errMsg = "";
      this.disabledOk = false;
      if (
        Number(this.freeAmount) < 0 &&
        Number(Math.abs(this.freeAmount)) > Number(this.resConfig.LimitValue)
      ) {
        this.disabledOk = true;
        this.errMsg =
          "抹零金额不能超过最大限制【" + this.resConfig.LimitValue + "】";
      }
    },
    handleBlur() {
      const _this = this;
      if (
        Number(Math.abs(this.freeAmount)) >
          Number(this.resConfig.RemindValue) &&
        !this.disabledOk
      ) {
        this.$confirm({
          title: "超额提醒",
          content: () => (
            <div>
              您的抹零金额为
              <span style="color:#f00;font-size:15px">
                【{this.freeAmount}】
              </span>
              ，是否确定抹零？
            </div>
          ),
          width: 500,
          onOk() {},
          onCancel() {
            _this.MoneyAfterFreeRemnant = _this.info.UnPayAmount;
          }
        });
      }
    },
    onCancel() {
      this.visible = false;
    },
    onSubmit() {
      this.confirmLoading = true;

      this.$post("FreeRemnant", {
        OrderId: this.info.Id,
        MoneyAfterFreeRemnant: this.MoneyAfterFreeRemnant
      })
        .then(() => {
          this.confirmLoading = false;
          this.$message.success("操作成功");
          this.$emit("submit");
          this.visible = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.form-item {
  display: flex;
  margin-top: 15px;
  margin-bottom: 15px;
  label {
    min-width: 100px;
    text-align: right;
  }
  .ant-input-number {
    width: 130px;
  }
}
</style>
